import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'

const SAFE_LINK_REGEX = /^(https?:\/\/|mailto:|tel:)/i

export function buildExtensions({ placeholder, extraExtensions = [] } = {}) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      codeBlock: false
    }),
    Underline,
    Link.configure({
      openOnClick: false,
      autolink: true,
      validate: (href) => SAFE_LINK_REGEX.test(href),
      HTMLAttributes: {
        rel: 'noopener noreferrer nofollow',
        target: '_blank'
      }
    }),
    Placeholder.configure({
      placeholder: placeholder || ''
    }),
    ...extraExtensions
  ]
}
